import React from 'react';
import { Skeleton } from '@mui/material';

export const LoadingSkeleton = () => {
  return (
    <>
      <div className="extract-skeleton" data-testid="loading-skeleton">
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px' }} height={64} />
        <Skeleton sx={{ borderRadius: '8px', marginTop: '24px', marginLeft: 'auto' }} width={208} height={40} />
      </div>
    </>
  );
};
